import { useMemo } from "react";
import {
  useGetAllPermissionsQuery,
  useGetAllRolesQuery,
} from "app/services/api/rolesApi";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";
import { useSortedPermissionsWithEnforcement } from "./useSortedPermissionsWithEnforcement";

export const useHandleRoleListing = () => {
  const { data: permissionsData, isLoading: arePermissionsLoading } =
    useGetAllPermissionsQuery(undefined);

  const { data: rolesData, isLoading: areRolesLoading } =
    useGetAllRolesQuery(undefined);

  const rolesOptions = useMemo(() => {
    return (
      rolesData?.map((role: RoleModel) => ({
        value: role.id,
        label: role.display_name,
      })) || []
    );
  }, [rolesData]);

  const { sortedPermissionsData, handleCheckboxSelection } =
    useSortedPermissionsWithEnforcement(permissionsData);
  return {
    arePermissionsLoading,
    areRolesLoading,
    rolesOptions,
    sortedPermissionsData,
    handleCheckboxSelection,
  };
};
